<template>
<div class="chapter">
<div class="inner_page">
<p class="CT"><img alt="" src="images/contents.jpg" width="90%"/></p>
<p class="CCT"><span href="#/xhtml/title" title="Link target outside of Sample">Title Page</span></p>
<p class="CCT"><a href="#/xhtml/epigraph">Epigraph</a></p>
<p class="CCT"><a href="#/xhtml/map">Map</a></p>
<p class="CCT"><a href="#/xhtml/prologue">Prologue</a></p>
<p class="CCT"><a href="#/xhtml/chapter1">Chapter 1: Ice Lessons</a></p>
<p class="CCT"><a href="#/xhtml/chapter2">Chapter 2: A Star Named Svern</a></p>
<p class="CCT"><span href="#/xhtml/chapter3" title="Link target outside of Sample">Chapter 3: Not Mum</span></p>
<p class="CCT"><span href="#/xhtml/chapter4" title="Link target outside of Sample">Chapter 4: The Grieving Den</span></p>
<p class="CCT"><span href="#/xhtml/chapter5" title="Link target outside of Sample">Chapter 5: Lago Worries</span></p>
<p class="CCT"><span href="#/xhtml/chapter6" title="Link target outside of Sample">Chapter 6: Another Creature’s Secret</span></p>
<p class="CCT"><span href="#/xhtml/chapter7" title="Link target outside of Sample">Chapter 7: Moon Eyes</span></p>
<p class="CCT"><span href="#/xhtml/chapter8" title="Link target outside of Sample">Chapter 8: The Story of Moon Eyes</span></p>
<p class="CCT"><span href="#/xhtml/chapter9" title="Link target outside of Sample">Chapter 9: Cubs in a Jam</span></p>
<p class="CCT"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Chapter 10: More Than Prey</span></p>
<p class="CCT"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Chapter 11: Up the Tickle</span></p>
<p class="CCT"><span href="#/xhtml/chapter12" title="Link target outside of Sample">Chapter 12: The Ice Clock</span></p>
<p class="CCT"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Chapter 13: The Toothwalker</span></p>
<p class="CCT"><span href="#/xhtml/chapter14" title="Link target outside of Sample">Chapter 14: The Numera</span></p>
<p class="CCT"><span href="#/xhtml/chapter15" title="Link target outside of Sample">Chapter 15: Ghost Town</span></p>
<p class="CCT"><span href="#/xhtml/chapter16" title="Link target outside of Sample">Chapter 16: “Trust me … ”</span></p>
<p class="CCT"><span href="#/xhtml/chapter17" title="Link target outside of Sample">Chapter 17: Violation 106</span></p>
<p class="CCT"><span href="#/xhtml/chapter18" title="Link target outside of Sample">Chapter 18: Cell Block Six</span></p>
<p class="CCT"><span href="#/xhtml/chapter19" title="Link target outside of Sample">Chapter 19: Murmurs of the Gillygaskins</span></p>
<p class="CCT"><span href="#/xhtml/chapter20" title="Link target outside of Sample">Chapter 20: “I Don’t Want to Be a Tick Tock!”</span></p>
<p class="CCT"><span href="#/xhtml/chapter21" title="Link target outside of Sample">Chapter 21: The Powers of Third</span></p>
<p class="CCT"><span href="#/xhtml/chapter22" title="Link target outside of Sample">Chapter 22: Of Gillygaskins and Other Horrors</span></p>
<p class="CCT"><span href="#/xhtml/chapter23" title="Link target outside of Sample">Chapter 23: The Belong</span></p>
<p class="CCT"><span href="#/xhtml/chapter24" title="Link target outside of Sample">Chapter 24: Blown Away</span></p>
<p class="CCT"><span href="#/xhtml/chapter25" title="Link target outside of Sample">Chapter 25: The Country of the Skulls</span></p>
<p class="CCT"><span href="#/xhtml/chapter26" title="Link target outside of Sample">Chapter 26: Two Trails Meet</span></p>
<p class="CCT"><span href="#/xhtml/chapter27" title="Link target outside of Sample">Chapter 27: On the Spine</span></p>
<p class="CCT"><span href="#/xhtml/chapter28" title="Link target outside of Sample">Chapter 28: The Gilly Forest</span></p>
<p class="CCT"><span href="#/xhtml/chapter29" title="Link target outside of Sample">Chapter 29: Divine and Evil—Strange Denmates</span></p>
<p class="CCT"><span href="#/xhtml/chapter30" title="Link target outside of Sample">Chapter 30: Teach Us, Then, Skagen</span></p>
<p class="CCT"><span href="#/xhtml/chapter31" title="Link target outside of Sample">Chapter 31: Never to Rise</span></p>
<p class="CCT"><span href="#/xhtml/chapter32" title="Link target outside of Sample">Chapter 32: The Cubs Worry</span></p>
<p class="CCT"><span href="#/xhtml/chapter33" title="Link target outside of Sample">Chapter 33: A Spirit Guide?</span></p>
<p class="CCT"><span href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="CCT"><span href="#/xhtml/teaser" title="Link target outside of Sample">Teaser</span></p>
<p class="CCT"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
<p class="CCT"><span href="#/xhtml/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7d9973f8